import React, { useState } from "react";
import classNames from "classnames";
import DatePicker from "@/wmCompoments/datePicker";
import styles from '../styles/dateFilter.module.scss'
import { useTranslation } from "react-i18next";

export interface DateFilterProps {
  value: {
    startAt: string
    endAt: string
  }
  onChange: (start: string, end: string) => void
}

const DateFilter = ({ value, onChange }: DateFilterProps) => {
  const { t } = useTranslation('record')
  // 日期显示状态
  const [selectedRange, setSelectedRange] = useState<[Date | null, Date | null]>([null, null]);
  // 获得30天前时间
  const daysAgo30 = new Date();
  daysAgo30.setDate(daysAgo30.getDate() - 30);

  // 日期选项
  const options = [
    { title: t('today'), start: ut.getDateString(0), end: ut.getDateString(0) },
    { title: t('yesterday'), start: ut.getDateString(-1), end: ut.getDateString(-1) },
    { title: t('last7Days'), start: ut.getDateString(-6), end: ut.getDateString(0) },
    { title: t('last30Days'), start: ut.getDateString(-29), end: ut.getDateString(0) },
  ]

  return(
    <div className={styles.dateFilter}>
      {/* 自定义选择时间 */}
      <DatePicker
        className={styles.datePicker}
        value={selectedRange}
        minDate={daysAgo30}
        maxDate={new Date()}
        onChange={(dates: any) => {
          console.log(dates[0])
            setSelectedRange(dates)
            if (dates[0] && dates[1]) {
                onChange(ut.formatDateTo(dates[0]), ut.formatDateTo(dates[1]))
            } else {
              onChange(ut.getDateString(0), ut.getDateString(0))
            }
        }}
        render={(dates: any) => {
            if (!dates[0] && !dates[1]) {
                return `${t('registrationDate')}：All Range`
            }
            return `${t('registrationDate')}：${dates[0]?.toLocaleDateString()} - ${dates[1]?.toLocaleDateString()}`
        }}
      />

      {/* 今日，昨天，近7天，近30天按钮 */}
      <div className={styles.buttons}>
        {options.map((v,index)=>(
          <button 
            key={index}
            onClick={()=>onChange(v.start, v.end)}
            className={classNames(styles.item, {
              [styles.active]: value.startAt === v.start && value.endAt === v.end
            })}
          >
            {v.title}
          </button>
        ))}
      </div>
      
    </div>
  )
}

export default DateFilter